import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/ui/Tooltip';

import routes from 'app/routes';

import {
  MenuItem,
  ButtonGroup,
  DropdownButton,
} from 'react-bootstrap';

import DeleteValidator from '../DeleteValidator/Index';
import FillProfileInfo from '../FillProfileInfo/Index';
import DeletePopup from '../DeletePopup/Index';

import { useContext } from '../Context';

export default function Actions({ row }) {
  const { dispatch, actions } = useContext();

  const [showDeleteValidatorModal, setShowDeleteValidatorModal] = useState(false);
  const [showFillProfileInfoModal, setShowFillProfileInfoModal] = useState(false);
  const [showDeletePopupModal, setShowDeletePopupModal] = useState(false);

  const onEditClick = () => {
    document.location.href = routes.admin.coaches.edit(row.id);
  };

  const onImpersonateClick = () => {
    window.open(routes.api.users.impersonate(row.attributes.user_id), '_blank').focus();
  };

  const onDeleteValidatorClick = () => {
    setShowDeleteValidatorModal(true);
  };

  const onFillProfileInfoClick = () => {
    setShowFillProfileInfoModal(true);
  };

  const onDeleteClick = () => {
    setShowDeletePopupModal(true);
    // actions.destroy(dispatch, row.attributes.user_id);
  };

  const onRestoreClick = () => {
    actions.restore(dispatch, row.attributes.user_id);
  };

  return (
    <div className="action-wrapper">
      <ButtonGroup vertical block>
        <DropdownButton title={<i className="fa fa-ellipsis-v " />} bsStyle="link">
          <MenuItem onClick={() => onEditClick()}>
            Edit
          </MenuItem>
          <MenuItem onClick={() => onImpersonateClick()}>
            Impersonate
          </MenuItem>
          <MenuItem onClick={() => onFillProfileInfoClick()}>
            Profile Completion details
          </MenuItem>
          <MenuItem onClick={() => onDeleteValidatorClick()}>
            Deletion Status
          </MenuItem>
          <MenuItem onClick={() => onDeleteClick()}>
            Hard Delete
          </MenuItem>
          <MenuItem onClick={() => onRestoreClick()}>
            Restore
          </MenuItem>
        </DropdownButton>
      </ButtonGroup>

      <Tooltip />
      {showDeleteValidatorModal && <DeleteValidator row={row} closePopup={() => setShowDeleteValidatorModal(false)} />}
      {showFillProfileInfoModal && <FillProfileInfo row={row} closePopup={() => setShowFillProfileInfoModal(false)} />}
      {showDeletePopupModal && <DeletePopup row={row} closePopup={() => setShowDeletePopupModal(false)} />}
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
};
